/* ==========================================================================
   IRON CREST LEATHER — ui.js
   Chrome only: header state, announcement rotation, overlay panels, reveals,
   newsletter. Deliberately independent of the cinematic story so either can
   fail without taking the store down.
   Shopify: assets/ui.js, loaded with `defer` from layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- header */
  var header = document.getElementById('header');
  if (header) {
    var stuck = false;
    var onScroll = function () {
      var next = window.scrollY > 12;
      if (next !== stuck) {
        stuck = next;
        header.classList.toggle('is-stuck', stuck);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* -------------------------------------------------- announcement rotator */
  var announce = document.querySelector('[data-announce]');
  if (announce && !reduced) {
    var items = announce.querySelectorAll('.announce__item');
    if (items.length > 1) {
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 5500);
    }
  }

  /* -------------------------------------------------------- overlay panels */
  var scrim = document.querySelector('[data-scrim]');
  var openPanel = null;
  var lastFocus = null;

  function focusables(el) {
    return el.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])');
  }

  function open(name) {
    var panel = document.querySelector('[data-panel="' + name + '"]');
    if (!panel) return;
    if (openPanel) close();
    lastFocus = document.activeElement;
    openPanel = panel;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    document.body.classList.add('is-locked');
    var f = focusables(panel);
    if (f.length) f[0].focus();
  }

  function close() {
    if (!openPanel) return;
    openPanel.classList.remove('is-open');
    openPanel.setAttribute('aria-hidden', 'true');
    openPanel = null;
    if (scrim) scrim.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); open(opener.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]')) { close(); return; }
    if (scrim && e.target === scrim) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanel) { close(); return; }
    if (e.key !== 'Tab' || !openPanel) return;
    var f = focusables(openPanel);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // expose for product-card.js (open the drawer after a quick add)
  window.IronCrestUI = { open: open, close: close };

  /* --------------------------------------------------------------- reveals */
  var targets = document.querySelectorAll('[data-reveal]');
  if (!('IntersectionObserver' in window) || reduced) {
    Array.prototype.forEach.call(targets, function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    Array.prototype.forEach.call(targets, function (el) { io.observe(el); });
  }

  /* The hero is above the fold by definition — it introduces itself on load
     rather than waiting for an intersection it may never get. */
  var heroTargets = document.querySelectorAll('.scene--hero [data-reveal]');
  requestAnimationFrame(function () {
    Array.prototype.forEach.call(heroTargets, function (el) { el.classList.add('is-in'); });
  });

  /* ------------------------------------------------------------ newsletter */
  var nl = document.querySelector('[data-newsletter]');
  if (nl) {
    nl.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = nl.querySelector('input[type="email"]');
      var ok = document.querySelector('[data-newsletter-ok]');
      if (!input.value || input.value.indexOf('@') < 1) { input.focus(); return; }
      // Shopify: remove this handler and let {% form 'customer' %} post normally.
      if (ok) ok.classList.add('is-on');
      input.value = '';
    });
  }

})();

/* ==========================================================================
   Dropdown menus. Separate from the block above so it can be pasted on its
   own. Hover and focus-within open the panels in CSS alone; this adds the
   tap/click path and Escape. Everything delegates from document, so a header
   replaced by the theme editor keeps working with no re-initialisation.
   ========================================================================== */
(function () {
  'use strict';

  function closeMenus(except) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nav-item][data-open="true"]'), function (item) {
      if (item === except) return;
      item.removeAttribute('data-open');
      var t = item.querySelector('[data-nav-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-nav-toggle]');
    if (toggle) {
      e.preventDefault();
      var item = toggle.closest('[data-nav-item]');
      var open = item.getAttribute('data-open') === 'true';
      closeMenus(item);
      if (open) {
        item.removeAttribute('data-open');
      } else {
        item.setAttribute('data-open', 'true');
      }
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      return;
    }
    if (!(e.target.closest && e.target.closest('[data-nav-item]'))) closeMenus(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenus(null);
  });
})();
